/**
 * Where the simulation may appear. Nothing from it — no nav, no ads, no tasks,
 * no community UI — ever renders on the caregiver view, the intake form or
 * the Emergency Information Form.
 */
export function isSimSurfaceAllowed(path: string): boolean {
  if (path.startsWith("/care/") || path.startsWith("/intake/")) return false;
  return !/^\/child\/[^/]+\/eif\/?$/.test(path);
}

/** Signed-out pages: overlays (welcome sheet, cart drawer) stay off them. */
export function isSignedOutPath(path: string): boolean {
  return (
    path === "/" ||
    path === "/login" ||
    path === "/register" ||
    path === "/terms" ||
    path === "/privacy" ||
    path === "/forgot-password" ||
    path.startsWith("/reset-password") ||
    // The registry's family view (registry publicRoutes): visitors have no account.
    path.startsWith("/r/")
  );
}
